
import { defineComponent, ref, onMounted, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { t } = useI18n();
    const educateLevel = ref('');
    const options = [
      {
        value: t('educationLevel.highSchool'),
        label: t('educationLevel.highSchool'),
      },
      {
        value: t('educationLevel.juniorCollege'),
        label: t('educationLevel.juniorCollege'),
      },
      {
        value: t('educationLevel.underGraduate'),
        label: t('educationLevel.underGraduate'),
      },
      {
        value: t('educationLevel.graduate'),
        label: t('educationLevel.graduate'),
      },
      {
        value: t('educationLevel.doctor'),
        label: t('educationLevel.doctor'),
      },
    ];

    const personal = computed(() => props.userInfoList);

    watch(personal.value.postEducation, () => {
      personal.value.postEducation = !personal.value.postEducation;
    });

    const educateChoice = () => {
      if (educateLevel.value === t('educationLevel.highSchool')) {
        personal.value.education = 0;
      } else if (educateLevel.value === t('educationLevel.juniorCollege')) {
        personal.value.education = 1;
      } else if (educateLevel.value === t('educationLevel.underGraduate')) {
        personal.value.education = 2;
      } else if (educateLevel.value === t('educationLevel.graduate')) {
        personal.value.education = 3;
      } else if (educateLevel.value === t('educationLevel.doctor')) {
        personal.value.education = 4;
      }
    };

    onMounted(() => {
      switch (personal.value.education) {
        case 0:
          educateLevel.value = t('educationLevel.highSchool');
          break;
        case 1:
          educateLevel.value = t('educationLevel.juniorCollege');
          break;
        case 2:
          educateLevel.value = t('educationLevel.underGraduate');
          break;
        case 3:
          educateLevel.value = t('educationLevel.graduate');
          break;
        case 4:
          educateLevel.value = t('educationLevel.doctor');
          break;
        default:
          educateLevel.value = '';
      }
    });

    return { educateLevel, options, educateChoice, personal };
  },
});
